import React, { useState } from 'react';
import SeoMeta from '../../SEO/SeoMeta';
import { useNavigate } from "react-router-dom";
import ComingSoonModal from "../../../components/common/ComingSoonModal"; // Make sure path is correct!

import DashboardLock from '../../../modules/auth/DashboardLock';
import DashboardLayout from '../Common/Layouts/DashboardLayout';
import DashboardTabs from './/DashboardTabs';
import UserDirectoryBox from './/UserDirectoryBox';

// COMPONENTS
import DashboardStatsRow from './DashboardStatsRow';
import ProfileVerificationAlert from './ProfileVerificationAlert';
import AITipBox from './AITipBox';
import QuickActions from './QuickActions';
import DashboardPostInput from './DashboardPostInput';
import DashboardPostFeed from './DashboardPostFeed';
import DailyTaskChecklist from './DailyTaskChecklist';
import LevelProgressBar from './LevelProgressBar';
import BadgeShowcase from './BadgeShowcase';
import CalendarReminderBox from './CalendarReminderBox';
import MyAnalyticsBox from './MyAnalyticsBox';
import UpcomingBookingsBox from './UpcomingBookingsBox';
import OrderSummaryBox from './OrderSummaryBox';
import LearningProgressBox from './LearningProgressBox';
import DownloadsCenterBox from './DownloadsCenterBox';
import SecurityActivityBox from './SecurityActivityBox';
import UserTimelineBox from './UserTimelineBox';
import LiveChartBox from './LiveChartBox';

import AuthModal from '../../../modules/auth/AuthModal';

export default function Dashboard() {
  const [userRoles] = useState(['Freelancer', 'Investor']);
  const [activeRole, setActiveRole] = useState(userRoles[0]);
  const [showAuthModal, setShowAuthModal] = useState(true); // ✅ Modal trigger

    const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();

  // When modal is closed, redirect to landing page (e.g., "/")
  const handleModalClose = () => {
    setShowModal(false);
    navigate("/"); // Change "/" to your landing page route if different
  };

  const tabs = [
    {
      label: 'Overview',
      content: (
        <>
          <DashboardStatsRow />
          <ProfileVerificationAlert />
          <AITipBox />
          <QuickActions />
        </>
      ),
    },
    {
      label: 'Activity',
      content: (
        <>
          <DashboardPostInput />
          <DashboardPostFeed />
          <DailyTaskChecklist />
          <LevelProgressBar level={3} xp={65} />
          <BadgeShowcase />
        </>
      ),
    },
    {
      label: 'Learning',
      content: (
        <>
          <LearningProgressBox />
          <DownloadsCenterBox />
        </>
      ),
    },
    {
      label: 'Analytics',
      content: (
        <>
          <CalendarReminderBox />
          <MyAnalyticsBox />
          <UpcomingBookingsBox />
          <OrderSummaryBox />
          <LiveChartBox />
        </>
      ),
    },
    {
      label: 'Directory',
      content: (
        <>
          <UserDirectoryBox />
        </>
      ),
    },
    {
      label: 'Security',
      content: (
        <>
          <SecurityActivityBox />
          <UserTimelineBox />
        </>
      ),
    },
  ];

  return (
  <>
    <SeoMeta 
      title="My Dashboard — Million2Trillion (M2T)"
      description="Access your Million2Trillion verified dashboard. Monitor your learning, trading, analytics, bookings, directories, and growth activities all in one place."
      url="https://million2trillion.com/dashboard"
    />


    
    <div className="relative">    


  {/* your existing page content */}



      {/* Blur background if modal is open */}
      {/*<div className={`${showAuthModal ? 'blur-sm pointer-events-none' : ''} transition-all duration-300`}>*/}
        <div className="transition-all duration-300">
        <DashboardLayout>
          <h1 className="text-xl font-bold mb-4">📊 Welcome to Your Dashboard</h1>
          <DashboardTabs tabs={tabs} />
        </DashboardLayout>
      </div>

<ComingSoonModal open={showModal} onClose={handleModalClose} />
    </div>
    </>
  );
}
